import { createStore, applyMiddleware, compose } from 'redux';
import { logger } from '../middlewares/segmentMiddleware'
import thunk from 'redux-thunk';
import BaseReducer from '../reducers/index';

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

export default createStore(
    BaseReducer,
    composeEnhancers(applyMiddleware(thunk.withExtraArgument(), logger))
)


// WEBPACK FOOTER //
// /src/store/store.js